<!-- Depots Table  -->

<div class="depot_listing_page">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <!-- <div class="blue_header">
    <h1 class="heading">Carrier Driver</h1>
  </div> -->
  <!-- <app-filter [code]="code" [description]="description" [selectedItems]="selectedItems"
          (formValueChanged)="applyFilter($event)"></app-filter> -->

  <!-- <div class="page_header">
    <h1 class="heading">Drivers</h1>
    <p class="name">{{ user?.UserName }}</p>
  </div>
  <img
    src="../../../assets/newimg/arrow-1-3@2x.png"
    style="cursor: pointer; margin: 10px"
  /> -->

  <!-- <div class="add_btn_wrap flex_end" style="float: right">
    <button type="button" (click)="onAddDriver()" class="btn btn_primary">
      + Add Driver
    </button>
  </div> -->

  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Delete Confirmation</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        &times;
      </button>
    </div>
    <div class="modal-body">
      <input type="hidden" [(ngModel)]="removeRef" name="id" />
      <span [innerHTML]="deleteConfirm"></span>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-danger btn-sm"
        (click)="onDelete(removeRef.id)"
        style="width: 80px"
      >
        Yes
      </button>
      <button
        class="btn btn-default btn-sm"
        (click)="modal.dismiss('Cross click')"
        style="width: 80px"
      >
        No
      </button>
    </div>
  </ng-template>

  <div class="table-responsive">
    <table class="table custom_table">
      <thead>
        <!-- <th>
          <input type="checkbox" value="" id="" name="" />
        </th> -->
        <th>Name</th>
        <!-- <th>Depot Name</th> -->
        <th>Gender</th>
        <th>ID/Passport Number</th>
        <th>Cell Phone Number</th>
        <th>License Type</th>
        <th>Actions</th>
      </thead>
      <tbody>
        <tr *ngFor="let driver of carrierDriverList">
          <!-- | paginate: { itemsPerPage: 10, currentPage: page } -->
          <!-- <td>
            <input type="checkbox" value="" id="" name="" />
          </td> -->
          <td>{{ driver.first_name }} {{ driver.last_name }}</td>
          <!-- <td>{{ driver.depot.name }}</td> -->
          <td>{{ driver.gender }}</td>
          <td *ngIf="driver.passport_number">{{ driver.passport_number }}</td>
          <td *ngIf="driver.id_number">{{ driver.id_number }}</td>
          <td>{{ driver.dial_code_cell }} {{ driver.cellphone }}</td>
          <td>{{ driver.license_type }}</td>
          <td>
            <div class="actions">
              <!-- <button
                type="button"
                (click)="onEditDriver(driver)"
                class="btn_icon"
                aria-label="Edit file"
              >
                <img src="assets/edit.png" alt="" />
              </button>
              <button
                type="button"
                class="btn_icon"
                (click)="onDeleteDriver(driver)"
                aria-label="Delete file"
              >
                <img src="assets/delete.png" alt="" />
              </button> -->
              <button
                type="button"
                (click)="onViewDetails(driver)"
                class="btn_icon"
                aria-label="View file"
              >
                <img src="assets/visibility.png" alt="" />
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr *ngIf="count > 10" class="pagination_row">
          <td colspan="12" class="rm-brd">
            <div class="row">
              <div class="col-2">
                <div
                  class="input-group mb-3 rm-brd"
                  style="width: 125px !important; height: 30px !important"
                >
                  <div class="input-group-prepend">
                    <label
                      class="input-group-text form-control-sm show-h"
                      for="show-id"
                      >Show:</label
                    >
                  </div>
                  <select
                    class="form-control form-control-sm show-h"
                    id="show-id"
                    [(ngModel)]="pageSize"
                    (change)="onChange()"
                  >
                    <option
                      *ngFor="let key of utility.pageItems"
                      [ngValue]="key"
                    >
                      {{ key }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-10">
                <pagination-controls
                  (pageChange)="utility.page = onNextOrPrevious($event)"
                  style="margin-right: 0px !important; float: right !important"
                ></pagination-controls>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="isEmpty">
          <td colspan="4" class="rm-brd">
            <span class="text-info text-small">No carrier drivers found.</span>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
 <!-- Driver View Details modal -->
 <ng-template #detail let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Driver Details</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      &times;
    </button>
  </div>
  <div class="modal-body">
    <app-carrier-driver-details
      [carrierId]="carrierId"
      [driverDetails]="driver"
      (saved)="modal.dismiss('Cross click')"
    ></app-carrier-driver-details>
  </div>
</ng-template>